import React from 'react';
import DashboardMain from './DashboardMain';

function Dashboard() {
  return <DashboardMain />;
}

export default Dashboard;